// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { DesignStudioWeddingRingSuccessNewCustomerFragmentDoc } from './success/designStudioWeddingRingSuccessNewCustomer.fragment.generated';
export const DesignStudioWeddingRingNewCustomerResponseFragmentDoc = gql`
    fragment designStudioWeddingRingNewCustomerResponse on CatalogueDesignStudioCheckoutWeddingRingNewCustomerResponse {
  ...designStudioWeddingRingSuccessNewCustomer
}
    ${DesignStudioWeddingRingSuccessNewCustomerFragmentDoc}`;